import { combineReducers } from "redux";
import AuthReducer from "modules/auth/reducer";
import { UserReducer, UserDetailReducer } from "modules/userManagement/reducer";
import {
  CarsTypeReducer,
  DiscountReducer,
} from "modules/utilityManagement/reducer";
import { ServiceTypeReducer } from "modules/serviceManagement/reducer";
import { ServicePricingReducer } from "modules/servicePricingManagement/reducer";
import { OrderManagementReducer } from "modules/orderManagement/reducer";
import { CarCompanyReducer } from "modules/company/reducer";
import TestimonialReducer from "modules/testimonial/reducer";
import { CouponReducer } from "modules/coupon/reducer";

const appReducer = combineReducers({
  AuthReducer,
  UserReducer,
  UserDetailReducer,
  CarsTypeReducer,
  ServiceTypeReducer,
  ServicePricingReducer,
  OrderManagementReducer,
  CarCompanyReducer,
  DiscountReducer,
  TestimonialReducer,
  CouponReducer,
});

const RootReducer = (state: any, action: any) => {
  if (action.type === "LOGOUT") {
    state = undefined; // Reset state to undefined
  }
  return appReducer(state, action);
};

export default RootReducer;
